(function () {
  if (window.CelestyCartCampaignsLoaded) return;
  window.CelestyCartCampaignsLoaded = true;

  const config = window.CelestyCartCampaignsConfig || {};
  const nativeFetch = window.fetch.bind(window);

  const THRESHOLDS = config.thresholds || {};
  const CURRENT_COUNTRY = config.country;
  const HIDE_SHIPPING_GOAL = Boolean(config.isShippingGoalHidden);
  const IS_DISTRIBUTOR = Boolean(config.isDistributor);

  const ENROLLMENT_KIT_PRODUCT_IDS =
    Array.isArray(config.enrollmentKitProductIds) && config.enrollmentKitProductIds.length
      ? config.enrollmentKitProductIds.map(id => String(id).trim()).filter(Boolean)
      : [
          '9445641060566',
          '9207748788438',
          '9216167411926'
        ];

  const IS_CART_PAGE =
    window.location.pathname === '/cart' ||
    window.location.pathname.endsWith('/cart');

  const updateTimers = [];

  function getCountryThresholds() {
    return THRESHOLDS[CURRENT_COUNTRY] || null;
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || config.currency || 'USD'
    }).format(cents / 100);
  }

  async function getCart() {
    const response = await nativeFetch(`/cart.js?t=${Date.now()}`, {
      cache: 'no-store'
    });

    return response.json();
  }

  function getDiscountedCartSubtotal(cart) {
    if (!cart) return 0;

    if (typeof cart.total_price === 'number') {
      return Number(cart.total_price || 0);
    }

    if (typeof cart.items_subtotal_price === 'number') {
      return Number(cart.items_subtotal_price || 0);
    }

    if (typeof cart.original_total_price === 'number') {
      return Number(cart.original_total_price || 0);
    }

    return 0;
  }

  function cartHasEnrollmentKit(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(item => {
      return ENROLLMENT_KIT_PRODUCT_IDS.includes(String(item.product_id));
    });
  }

  function updateGoalBar(element, options) {
    if (!element) return;

    const title = element.querySelector('.celesty-cart-goal__title');
    if (!title) return;

    const {
      threshold,
      subtotal,
      currency,
      lockedText,
      unlockedText
    } = options;

    if (!threshold || threshold <= 0) {
      element.hidden = true;
      return;
    }

    const remaining = threshold - subtotal;
    const progress = Math.min((subtotal / threshold) * 100, 100);

    element.hidden = false;
    element.style.setProperty('--progress', `${progress}%`);

    if (remaining > 0) {
      element.classList.remove('celesty-cart-goal--done');
      title.innerHTML = lockedText.replace('{remaining}', formatMoney(remaining, currency));
    } else {
      element.classList.add('celesty-cart-goal--done');
      title.innerHTML = unlockedText;
    }
  }

  function updateCartGoals(cart) {
    const thresholds = getCountryThresholds();

    const shippingGoals = document.querySelectorAll('.celesty-shipping-goal');
    const distributorShippingGoals = document.querySelectorAll('.celesty-distributor-shipping-goal');
    const oldDiscountGoals = document.querySelectorAll('.celesty-gift-goal');

    oldDiscountGoals.forEach(goal => {
      goal.hidden = true;
    });

    if (!thresholds) {
      shippingGoals.forEach(goal => { goal.hidden = true; });
      distributorShippingGoals.forEach(goal => { goal.hidden = true; });
      return;
    }

    const hasEnrollmentKit = cartHasEnrollmentKit(cart);
    const shippingSubtotal = getDiscountedCartSubtotal(cart);

    // Mevcut genel kargo kampanyasi degismedi.
    shippingGoals.forEach(goal => {
      if (HIDE_SHIPPING_GOAL || IS_DISTRIBUTOR || hasEnrollmentKit || !thresholds.shipping) {
        goal.hidden = true;
        return;
      }

      updateGoalBar(goal, {
        threshold: thresholds.shipping,
        subtotal: shippingSubtotal,
        currency: cart.currency,
        lockedText: 'Buy <strong>{remaining}</strong> more to enjoy <strong>FREE Shipping</strong>',
        unlockedText: 'Congrats! You are eligible for <strong>FREE Shipping</strong>'
      });
    });

    // Yeni Distributor kampanyasi: US $99 / CA C$138.
    distributorShippingGoals.forEach(goal => {
      if (!IS_DISTRIBUTOR || !thresholds.distributorShipping) {
        goal.hidden = true;
        return;
      }

      updateGoalBar(goal, {
        threshold: thresholds.distributorShipping,
        subtotal: shippingSubtotal,
        currency: cart.currency,
        lockedText: 'Buy <strong>{remaining}</strong> more to enjoy <strong>FREE Shipping</strong>',
        unlockedText: 'Congrats! You are eligible for <strong>FREE Shipping</strong>'
      });
    });
  }

  async function refreshCartCampaigns() {
    try {
      const cart = await getCart();
      updateCartGoals(cart);
    } catch (error) {
      console.error('Celesty cart campaigns update error:', error);
    }
  }

  function scheduleCartCampaignUpdate(delay = 300) {
    const timer = setTimeout(function () {
      refreshCartCampaigns();
    }, delay);

    updateTimers.push(timer);

    if (updateTimers.length > 20) {
      const oldTimer = updateTimers.shift();
      clearTimeout(oldTimer);
    }
  }

  function isCartMutationUrl(url) {
    return (
      url &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      )
    );
  }

  function isCartInteraction(event) {
    if (!event.target || !event.target.closest) return false;

    return Boolean(
      event.target.closest('#MinimogCartDrawer') ||
      event.target.closest('form[action*="/cart"]') ||
      event.target.closest('[data-celesty-cart-campaigns]') ||
      IS_CART_PAGE
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleCartCampaignUpdate(0);
    scheduleCartCampaignUpdate(700);
    scheduleCartCampaignUpdate(1500);
  });

  document.addEventListener('cart:updated', function () {
    scheduleCartCampaignUpdate(300);
    scheduleCartCampaignUpdate(1000);
    scheduleCartCampaignUpdate(1800);
  });

  document.addEventListener('cart:refresh', function () {
    scheduleCartCampaignUpdate(300);
    scheduleCartCampaignUpdate(1000);
    scheduleCartCampaignUpdate(1800);
  });

  document.addEventListener('click', function (event) {
    if (!isCartInteraction(event)) return;
    if (!event.target || !event.target.closest) return;

    if (
      event.target.closest('[name="plus"]') ||
      event.target.closest('[name="minus"]') ||
      event.target.closest('.quantity__button') ||
      event.target.closest('.m-quantity__button') ||
      event.target.closest('m-quantity-input') ||
      event.target.closest('a[href*="/cart/change"]') ||
      event.target.closest('a[href*="quantity=0"]') ||
      event.target.closest('[data-cart-remove]') ||
      event.target.closest('[data-remove]') ||
      event.target.closest('.cart-remove-button') ||
      event.target.closest('.m-cart-item__remove') ||
      event.target.closest('m-cart-remove-button')
    ) {
      scheduleCartCampaignUpdate(500);
      scheduleCartCampaignUpdate(1200);
      scheduleCartCampaignUpdate(2200);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!isCartInteraction(event)) return;

    if (event.target.matches('input[name="updates[]"], input[type="number"], .m-quantity__input')) {
      scheduleCartCampaignUpdate(500);
      scheduleCartCampaignUpdate(1200);
      scheduleCartCampaignUpdate(2200);
    }
  }, true);

  window.fetch = async function () {
    const requestUrl = typeof arguments[0] === 'string'
      ? arguments[0]
      : arguments[0] && arguments[0].url;

    const isMutation = isCartMutationUrl(requestUrl);
    const response = await nativeFetch.apply(this, arguments);

    if (isMutation) {
      scheduleCartCampaignUpdate(400);
      scheduleCartCampaignUpdate(1000);
      scheduleCartCampaignUpdate(1800);
      scheduleCartCampaignUpdate(2800);
    }

    return response;
  };

  if (window.XMLHttpRequest) {
    const nativeXHROpen = window.XMLHttpRequest.prototype.open;
    const nativeXHRSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this._celestyCartMutationUrl =
        typeof url === 'string' && isCartMutationUrl(url) ? url : null;

      return nativeXHROpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this._celestyCartMutationUrl) {
        this.addEventListener('loadend', function () {
          scheduleCartCampaignUpdate(400);
          scheduleCartCampaignUpdate(1000);
          scheduleCartCampaignUpdate(1800);
          scheduleCartCampaignUpdate(2800);
        });
      }

      return nativeXHRSend.apply(this, arguments);
    };
  }
})();
